import styled from 'styled-components';

import { GenericSpan } from 'commonStyles';

export const OopTagWrapper = styled(GenericSpan)`
	display: inline-flex;
	align-items: center;
	gap: 4px;
	border-radius: 4px;
	letter-spacing: 0.2px;
	white-space: nowrap;
`;

export const OopTooltipList = styled.ul`
	margin: 0;
	padding: 0 0 0 16px;
	list-style: disc;

	& li + li {
		margin-top: 4px;
	}
`;

export const OopTooltipBody = styled(GenericSpan)`
	display: block;
	max-width: 300px;
	word-break: break-word;
	overflow-wrap: anywhere;
	color: inherit;
`;
